import React, { Component, Fragment } from 'react';
import LandingpageImage from '../assets/landingpage.jpg';
import Logo from '../assets/logo.svg';
import Bed from '../assets/bed.svg';
import Food from '../assets/food.svg';
import Ocean from '../assets/ocean.svg';

class App extends Component {
  render() {
    return (
      <Fragment>
        <div>
          <div className="icon-container">
            <img className="logo" src={Logo} alt=""/>
            <img className="icon" src={Bed} alt=""/>
            <img className="icon" src={Food} alt=""/>
            <img className="icon" src={Ocean} alt=""/>
          </div>
          <img src={LandingpageImage} alt="" className="background-image"/>
          <div className="text-container">
            <h3>Welcome to Miramar</h3>
            <p>Created by old friends with a shared dream of creating something akin to a commune for their friends and family, Miramar transforms an old seaside café into a temporary home with it’s own eating area, making Miramar a place for dining, sleeping and enjoying the simplest ways of life at Fonte da Telha, Portugal.</p>
            <p>Miramar is a summer retreat by André Saraiva in collaboration with his friend, Charlie Hedin of Danish textile brand Tekla Fabrics. Nestled on the beach of a small fisherman’s village, Miramar houses three double bedrooms, all curated by Tekla Fabrics, with a bespoke and intimate approach to the temporary home that is Miramar.</p>
            <p>Alongside this is an in-house eatery curated by artistic chef JoJo Vávra, using organic ingredients sourced from the area around Miramar in the summer period along with the freshest fish available, brought directly from the fishermen’s boats to the restaurant.</p>
            <p>During the summer, talented friends will stay and join our chef JoJo to interpret the menu.</p>
            <p>Miramar is placed in the small village of Fonte da Telha, 35-minute south of Lisbon. The season at Miramar runs from July through September.</p>
            <p>Inquire bookings at: <a href="mailto:reception@petitemiramar.com">reception@petitemiramar.com</a></p>
          </div>
        </div>
        <hr className="horizontal-line" />
        <div className="fa-container">
          <span>
            <a target="_blank" href="https://www.instagram.com/petitemiramar/"><i className="fa fa-instagram"/></a>
            <a target="_blank" href="https://open.spotify.com/user/bj3q21zapzgtcl03gy9o7x2of/playlist/3ijOO1j4nQYeTW7YPxQNF5?si=w7Aj2jPqTym222uGh7dBkQ"><i className="fa fa-spotify"/></a>
          </span>
        </div>
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/App.js